// @flow

import {
  differenceInCalendarDays,
  differenceInHours,
  differenceInYears,
  format,
  isValid,
  parse,
  parseISO,
} from 'date-fns';
import {de} from 'date-fns/locale';

export const parseDateStringWithoutTz = (dateString: string): string => {
  return dateString.replace(/[+-]\d\d:\d\d$/, 'Z');
};

export const fromToDate = (from: string, to: string): string => {
  return `${format(Date.parse(from), 'dd.MM.yyyy')} - ${format(
    Date.parse(to),
    'dd.MM.yyyy'
  )}`;
};

export const formatDateStringToISO = (dateString: string = ''): string => {
  const isoDate = parse(dateString, 'dd.MM.yyyy', new Date());
  if (dateString.length !== 10 || !isValid(isoDate)) {
    return dateString;
  }

  return format(isoDate, 'yyyy-MM-dd');
};

export const formatShortISO = (dateString: string = ''): string => {
  const isoDate = parseISO(dateString);
  if (dateString.length !== 25 || !isValid(isoDate)) {
    return dateString;
  }

  return format(isoDate, 'yyyy-MM-dd');
};

export const formatISOtoDateString = (isoString: string = ''): string => {
  const isoDate = parseISO(isoString);
  if (isoString?.length <= 0 || !isValid(isoDate)) {
    return isoString;
  }

  return format(isoDate, 'dd.MM.yyyy');
};

export const formatISOtoDateTimeString = (isoString: string = ''): string => {
  const isoDate = parseISO(isoString);
  if (isoString?.length <= 0 || !isValid(isoDate)) {
    return isoString;
  }

  return format(isoDate, 'dd.MM.yyyy, HH:mm');
};

export const dateTimeRange = (from: string, to: string): string => {
  const options = {
    locale: de,
  };
  return (
    format(Date.parse(from), 'HH:mm', options) +
    ' – ' +
    format(Date.parse(to), 'HH:mm', options)
  );
};

// parse form date format and return date object
export const parseFormDate = (date: string): Date => {
  return parse(date, 'dd.MM.yyyy', new Date());
};

// returns years between arrival date and birthday
export const calculateToArrivalDiff = (
  birthday: Date,
  arrivalDate: Date
): number => {
  return differenceInYears(arrivalDate, birthday);
};

export const diffInDays = (
  departureTime: string,
  arrivalTime: string
): number => {
  return differenceInCalendarDays(
    new Date(arrivalTime),
    new Date(departureTime)
  );
};

export const diffInHours = (
  departureTime: string,
  arrivalTime: string
): number => {
  return differenceInHours(new Date(arrivalTime), new Date(departureTime));
};
